var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opple-auth",class:{ inlineBlock: _vm.inline },style:(_vm.extendsStyle)},[(_vm.status === 1)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }